import { useEffect, useState } from "react";

export default function useAuth() {
    const [auth, setAuth] = useState(undefined);
    const [cleanUp, setCleanUp] = useState(false);
    const [reload, setReload] = useState(true);
    useEffect(() => {
        if (reload) {
            if (localStorage.getItem("auth")) {
                setAuth(JSON.parse(localStorage.getItem("auth")));
            }
            else {
                setAuth(undefined);
            }
            setReload(false);
        }
    }, [reload]);
    useEffect(() => {
        if (cleanUp) {
            localStorage.removeItem("auth");
            setReload(true);
            setCleanUp(false);
        }
    }, [cleanUp]);
    const updateAuth = (authInfo) => {
        localStorage.setItem("auth", JSON.stringify(authInfo));
        setReload(true);
    };
    const clearAuth = () => {
        setCleanUp(true);
    };


    return { auth, updateAuth, clearAuth };

}